export const RELATIONSHIP = [
  {
    name: 'Self',
    relations: [
      {
        label: 'Self',
        value: 'Self'
      }
    ]
  },
  {
    name: 'Parent',
    relations: [
      {
        label: 'Father',
        value: 'Father'
      },
      {
        label: 'Mother',
        value: 'Mother'
      },
      {
        label: 'Grandfather',
        value: 'Grandfather'
      },
      {
        label: 'Grandmother',
        value: 'Grandmother'
      }
    ]
  },
  {
    name: 'Spouse',
    relations: [
      {
        label: 'Husband',
        value: 'Husband'
      },
      {
        label: 'Wife',
        value: 'Wife'
      }
    ]
  },
  {
    name: 'Child',
    relations: [
      {
        label: 'Son',
        value: 'Son'
      },
      {
        label: 'Daughter',
        value: 'Daughter'
      },
      {
        label: 'Twins',
        value: 'Twins'
      },
      {
        label: 'Grandson',
        value: 'Grandson'
      },
      {
        label: 'Granddaughter',
        value: 'Granddaughter'
      }
    ]
  },
  {
    name: 'Sibling',
    relations: [
      {
        label: 'Brother',
        value: 'Brother'
      },
      {
        label: 'Sister',
        value: 'Sister'
      },
    ]
  },
  {
    name: 'Others',
    relations: [
      {
        label: 'Friend',
        value: 'Friend'
      },
      {
        label: `Friend's Family`,
        value: `Friend's Family`
      },
      {
        label: 'Cousin',
        value: 'Cousin'
      },
      {
        label: 'Uncle',
        value: 'Uncle'
      },
      {
        label: 'Aunt',
        value: 'Aunt'
      },
      {
        label: 'Nephew',
        value: 'Nephew'
      },
      {
        label: 'Niece',
        value: 'Niece'
      },
      {
        label: 'Colleague',
        value: 'Colleague'
      },
      {
        label: 'Relative',
        value: 'Relative'
      },
      {
        label: 'Legal ward',
        value: 'Legal ward'
      },
      {
        label: 'Other',
        value: 'Other'
      }
    ]
  }
];
